


















import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { ISos } from '../../store/modules/views/sos/states'
import VueExtendedBaseComponent from '../../VueExtendedBaseComponent.vue'

@Component
export default class CreateSosDialog extends VueExtendedBaseComponent {
  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  get fieldValidate() {
    return this.formInstant.validate()
  }

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get createSosDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.createSosAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get validateInput() {

    return this.nameValidate(this.name) && this.phoneValidate()
  }
  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private sos!: ISos & {roles: string[], permissions: string[], accounts: string[]}
  private loading = false
  private urlSos = ''

  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private activePicker = null
  private valid = false
  private name = ''
  private phoneNumber = ''

  private phoneRules = [
    (phone: string) => !!phone || 'กรุณากรอกหมายเลขโทรศัพท์',
    (phone: string) => (phone.match(/(0|66|\+66)[1-9]{1}[0-9]{7,8}/g)!.join('') === phone) || 'รูปแบบหมายเลขโทรศัพทไม่ถูกต้อง',
  ]

  private requireInput(value) {  return value !== '' || 'จำเป็นต้องกรอก' }

  get invalidateInput() {
    return _.some(
        [
          this.validateInputFromType('number', this.phoneNumber, true),
        ],
        (item) => item !== true,
    )
  }

  private phoneValidate() {
    return /^(0|66|\+66)[1-9]{1}[0-9]{7,8}$/.test(
        this.phoneNumber) || false
  }

  private async createSosAction() {
    const validate = this.formInstant.validate()
    if (validate) {
      this.loading = true
      const url = process.env.VUE_APP_API_URL + '/v1/sos'
      const sosData = {
          name: this.name,
          phone: this.phoneNumber,
      }
      this.loading = true
      try {
        await HttpRequestServiceWithToken.post(url, sosData, async () => {
          this.updateSnackbar({txt: 'บันทึกข้อมูลสำเร็จ', type: 'success'})
          await this.callback()
          this.loading = false
          this.closeDialog()
        })
      } catch (e) {
        this.loading = false
      }
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
